/**
 * Stub pour @nestjs/swagger - les décorateurs sont supprimés à la compilation TypeScript
 * Ce fichier existe uniquement pour éviter les erreurs de résolution dans Vite
 */

// Les décorateurs sont supprimés à la compilation TypeScript de toute façon
// On exporte des fonctions vides pour éviter les erreurs de résolution
export const ApiProperty = () => {};
export const ApiTags = () => {};
export const ApiOperation = () => {};
export const ApiBody = () => {};
export const ApiResponse = () => {};
export const ApiBadRequestResponse = () => {};
export const ApiBearerAuth = () => {};
export const ApiSecurity = () => {};
export const ApiParam = () => {};
export const ApiQuery = () => {};
export const ApiHeader = () => {};
export const ApiOkResponse = () => {};
export const ApiUnauthorizedResponse = () => {};
export const ApiForbiddenResponse = () => {};
export const ApiNotFoundResponse = () => {};
export const ApiInternalServerErrorResponse = () => {};
export const ApiPropertyOptional = () => {};
export const ApiExtraModels = () => {};
export const ApiConsumes = () => {};
export const ApiProduces = () => {};
export const ApiExtension = () => {};
export const ApiExcludeEndpoint = () => {};
export const ApiExcludeController = () => {};
export const ApiHideProperty = () => {};

// Utility functions (not decorators) - used with extends
// These return the class itself, TypeScript handles the type transformation
export function PartialType<T>(
  classRef: new (...args: any[]) => T
): new (...args: any[]) => Partial<T> {
  return classRef as any;
}

export function PickType<T, K extends keyof T>(
  classRef: new (...args: any[]) => T,
  keys: readonly K[]
): new (...args: any[]) => Pick<T, K> {
  return classRef as any;
}

export function OmitType<T, K extends keyof T>(
  classRef: new (...args: any[]) => T,
  keys: readonly K[]
): new (...args: any[]) => Omit<T, K> {
  return classRef as any;
}

export function IntersectionType<A, B>(
  classARef: new (...args: any[]) => A,
  classBRef: new (...args: any[]) => B
): new (...args: any[]) => A & B {
  return classARef as any;
}

// Utility function for Swagger schema paths
export function getSchemaPath(classRef: new (...args: any[]) => any): string {
  // Return a placeholder path - this is only used for Swagger documentation generation
  return `#/components/schemas/${classRef.name || 'Unknown'}`;
}
